import useStore from '../store/useStore'

export default (list: string) => {
  return useStore(
    state => state.regimens?.filter(r => r.list === list) || []
  )
}
